import { render, staticRenderFns } from "./ReadCompliance.vue?vue&type=template&id=24b758a8"
import script from "./ReadCompliance.vue?vue&type=script&lang=js"
export * from "./ReadCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports